import Alpine from "alpinejs";
import scrollSpy from '@sidsbrmnn/scrollspy'

Alpine.data('hashMenu', () => ({
    init() {
        const element = this.$root;
        const options = {
            sectionSelector: `#${element.dataset.contentId} [id]`, // Query selector to your sections
            targetSelector: 'a', // Query selector to your elements that will be added `active` class
            offset: 105,  // Menu item will activate before scroll to a matched section 104px
            hrefAttribute: 'href',
            activeClass: 'text-black xl:!border-secondary',
            onActive: (el) => {
                const elementWidth = element.getBoundingClientRect().width;
                const elBox = el.getBoundingClientRect();
                const isWider = elBox.width > elementWidth;
                const x = elBox.left + element.scrollLeft + (isWider ? -24 : (elBox.width -  elementWidth) / 2 - 16);

                element.scroll({
                    left: x,
                    behavior: 'smooth'
                });
            }
        }

        // Initialize
        scrollSpy(this.$root, options)

        window.addEventListener("scroll", () => {
            const stickyTop = parseInt(window.getComputedStyle(element.parentNode).top);
            const currentTop = element.parentNode.getBoundingClientRect().top;
            element.parentNode.classList.toggle("is-sticky", currentTop === stickyTop);
        });
    },
}));
